import { ActionType, getType } from 'typesafe-actions'
import { v4 as uuid } from 'uuid'
import * as actions from './actions'
import N from '../../utils/assert-never'

import { initial as initialState, Type as State } from './state'

export type Action = ActionType<typeof actions>

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  switch (action.type) {
    case getType(actions.showNotification):
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...action.payload,
            id: uuid(),
          },
        ],
      }

    case getType(actions.closeNotification):
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => n.id !== action.payload,
        ),
      }

    case getType(actions.error):
      return {
        ...state,
        error: action.payload,
      }

    case getType(actions.apiServerError):
      return {
        ...state,
        error: action.payload,
      }
  }

  return N(action, state)
}
